import {IContentInfo} from '../types/types';

export function getMatchedContent(id: string, data: IContentInfo[]) {
    return (data.filter((content: IContentInfo) => content.id === Number(id))[0]);
}
